import { actions, getters } from './state'

export const SettingsState = {
  ...actions,
  ...getters
}